


import XImg from 'vux/src/components/x-img/index.vue'
import LoadMore from 'vux/src/components/load-more/index.vue'





export default {

components: { XImg, LoadMore },
data() {

return {
channelList: null, //轮播
ac_area_id: -1, //选中的地区id
areaList: null, //区域
intangibleList: null,
mapObj: null,
mapMaxZoom: 18, //地图最大层级
mapMinZoom: 5, //地图最小层级
mapLat: 30.244132,
mapLng: 120.147476,
curMarkers: []
};
},
filters: {
setDis(val) {
let dis = (val / 1000).toFixed(1) + "km";
return dis;
}
},

computed: {},

watch: {},

methods: {
getIntangibleList(area_id) {
let that = this;
that.get({
url: that.GLOBAL.BASE_URL + "/api/v1/getRedMarkList",
params: {


lng: localStorage.getItem("lng"),
lat: localStorage.getItem("lat"),
area_id: area_id
},
isShowLoading: true,
success: function(data) {
console.log(data.data);
that.intangibleList = data.data.data.intangibleList;
that.setPoi(data.data.data.intangibleList);
if (that.mapObj) {
} else {
that.setMap();
}
that.mapObj.clearMap();
that.mapObj.add(that.curMarkers);
}
});
},
changeArea(id, i) {
let that = this;
if (id == this.ac_area_id) {
return;
} else {
this.ac_area_id = id;
this.getIntangibleList(id);
this.$nextTick(function() {
that.scrollMiddle(
document.querySelectorAll("#areaList .area-item")[i],
document.getElementById("areaList")
);
if (id != -1) {

that.mapObj.setCenter([
that.areaList[i].longitude_gcj,
that.areaList[i].latitude_gcj
]);
} else {

that.mapObj.setCenter([that.mapLng, that.mapLat]);
}
});
}
},
getArea() {
let that = this;
that.get({
url: that.GLOBAL.BASE_URL + "/api/v1/getZJAreaList",
params: {},
isShowLoading: false,
success: function(data) {
console.log(data.data);
that.areaList = data.data.data.areaList;

}
});
},
setMap() {
let that = this;
this.mapObj = new AMap.Map("container", {
view: new AMap.View2D({

center: new AMap.LngLat(this.mapLng, this.mapLat),
zoom: 9, //设置地图缩放级别
rotation: 0 
}),
resizeEnable: true,
zooms: [this.mapMinZoom, this.mapMaxZoom],
features: ["bg", "road", "building"],
lang: "zh_cn" 
});
let leLayer = new AMap.TileLayer({

tileUrl:
"https://pic2.worldmaipu.com/api/v1/tile!GetBlodTile.action?x=[x]&z=[z]&y=[y]",
zIndex: 2
});
leLayer.setMap(that.mapObj);
this.mapObj.plugin(["AMap.ToolBar"], function() {
that.mapObj.addControl(
new AMap.ToolBar({
position: "RB",

liteStyle: true,
offset: new AMap.Pixel(10, 100)
})
);
});
},
setPoi(data) {
let that = this;
this.curMarkers = [];
for (let i in data) {
if (data[i].latitude && data[i].longitude) {
console.log(data[i].longitude, data[i].latitude);
let marker = new AMap.Marker({
content:
"<div class='poi'><div class='marker'></div><span class='poiName'>" +
data[i].name +
"</span></div>",
position: new AMap.LngLat(data[i].longitude, data[i].latitude),
offset: new AMap.Pixel(-12, -31),
extData: {
poiData: data[i]
}
});
AMap.event.addListener(marker, "click", function(e) {
let thisPosition = e.target.getPosition();
let extData = e.target.getExtData().poiData;
that.$router.push({
path: "museum",
query: { id: extData.id }
});
});

this.curMarkers.push(marker);
}
}
},

scrollMiddle(el, elParent) {
let a = el.offsetLeft;
let b = elParent.offsetWidth;
let c = el.offsetWidth;
elParent.scrollLeft = a - (b - c) / 2;
}
},

created() {},

mounted() {
this.getIntangibleList(this.ac_area_id);
this.getArea();
},
beforeCreate() {}, //生命周期 - 创建之前
beforeMount() {}, //生命周期 - 挂载之前
beforeUpdate() {}, //生命周期 - 更新之前
updated() {}, //生命周期 - 更新之后
beforeDestroy() {}, //生命周期 - 销毁之前
destroyed() {}, //生命周期 - 销毁完成
activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
};



// WEBPACK FOOTER //
// ./src/pages/index.vue